import { useEffect, useState } from 'react'
import { navigationRef } from 'APP/Nav'

// Note: Seems to have an incompatibility with hot reload

const stateToRoutes = (state) => state?.routes || []

export const useStackRoutes = () => {
  const [routes, setResult] = useState([])

  useEffect(() => {
    if (navigationRef.isReady()) {
      // Get initial state immediately
      const initialState = navigationRef.getRootState()
      const initialRoutes = stateToRoutes(initialState)
      setResult(initialRoutes)

      const unsubscribe = navigationRef.addListener('state', (_e) => {
        // Use getRootState() instead of e.data.state to get complete nested state
        const completeState = navigationRef.getRootState()
        setResult(stateToRoutes(completeState))
      })
      return unsubscribe
    }
  }, [])

  return routes
}
